import { useMutation } from "@tanstack/react-query";
import { deleteOrganizer } from "supabase/organizers";
import { queryClient } from "utils";

type UseDeleteOrganizerParams = {
  uid: string;
};

export const useDeleteOrganizer = (onSuccess: () => any) => {
  const mutation = useMutation({
    mutationFn: ({ uid }: UseDeleteOrganizerParams) => {
      return deleteOrganizer({ uid });
    },
    onSuccess: (_data, variables) => {
      queryClient.invalidateQueries({
        queryKey: ["organizers"],
      });

      onSuccess();
    },
    onError: (error) => {
      console.error(error);
    },
  });

  return mutation;
};
